/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileWithStatistics } from '../../models/profile-with-statistics';

export interface ListProfilesInIndustryGroup$Params {
  industryGroup: string;
  offset?: number;
  limit?: number;
}

export function listProfilesInIndustryGroup(http: HttpClient, rootUrl: string, params: ListProfilesInIndustryGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileWithStatistics>>> {
  const rb = new RequestBuilder(rootUrl, listProfilesInIndustryGroup.PATH, 'get');
  if (params) {
    rb.path('industryGroup', params.industryGroup, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProfileWithStatistics>>;
    })
  );
}

listProfilesInIndustryGroup.PATH = '/rest/profile/rank/industry-group/{industryGroup}';
